<div class="toggle-container">
    <label class="toggle-switch">
        <input type="checkbox" [checked]="checked">
        <span class="slider"></span>
        <span class="toggle-label">{{label | translate}}</span>
    </label>
</div>